<template>
  <div class="mIndex">
    <Header></Header>
    <NavBar :addRouterList="addRouterList"></NavBar>
    <div class="main">
      <router-view :key="$route.name"></router-view>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import NavBar from "@/components/NavBar.vue";
import BaseAPI from "@/api/BaseAPI";
import WebsiteApi from "@/api/WebsiteApi";
// 臨時寫死pt翻譯
import { tempTranslation } from "@/utils/TemporaryTranslation";
import { mapMutations, mapState } from "vuex";
export default {
  name: "Index",
  components: { Header, Footer, NavBar },
  data() {
    return {
      addRouterList: [],
    };
  },
  computed: {
    ...mapState({
      activityId: (state) => state.activityId,
    }),
  },
  async created() {
    await this.getActivity();
    await this.getBooth(this.activityId);
    await this.getOtherBooth(this.activityId);
    this.setIsRouterChange();
  },
  methods: {
    ...mapMutations({
      setIsRouterChange: "setIsRouterChange",
      setActivity: "setActivity",
    }),
    async getActivity() {
      try {
        const actDetail = await WebsiteApi.getActivity();
        this.setActivity(actDetail);
      } catch (e) {
        this.$error(e);
      }
    },
    // 獲取展板
    async getBooth(activityId) {
      try {
        // 动态添加route 添加列表路由 添加詳情路由
        const sort = "code:asc";
        const displayModes = ["EXHIBITOR_LIST", "EXHIBITION_BOARD_LIST"];
        const boothList = await BaseAPI.boothsAreaCategory(
          0,
          9999,
          {
            activityId,
            displayModes,
          },
          sort
        );
        if (boothList && Array.isArray(boothList.content)) {
          const arr = [];
          boothList.content.forEach((item) => {
            // 臨時加上簡介的pt翻譯
            const summaryPt = item?.summaryPt || tempTranslation(item.summary);
            const obj = {
              path: `/booth-${item.id}`,
              name: `Booth${item.id}`,
              component: () => import("@/pages/Booth/Booth"),
              meta: {
                mode: "changeable",
                summaryPt: summaryPt,
                ...item,
              },
            };
            arr.push(obj);
            this.$router.addRoute("Index", obj);
          });
          this.addRouterList = [...this.addRouterList, ...arr];
        }
      } catch (e) {
        this.$error(e);
      }
    },
    // 獲取其他展板的內容
    async getOtherBooth(activityId) {
      try {
        const ApiRes = await BaseAPI.getExhibitionArea({
          activityId,
          status: "PUBLISHED",
        });
        // 臨時翻轉數組
        const otherBoothList = ApiRes.reverse();
        if (Array.isArray(otherBoothList)) {
          const arr = [];
          otherBoothList.forEach((item) => {
            // 臨時加上簡介的pt翻譯
            const summaryPt = item?.summaryPt || tempTranslation(item.summary);
            const obj = {
              path: `/technology-${item.id}`,
              name: `Technology${item.id}`,
              component: () => import("@/pages/TechnologyPush"),
              meta: {
                mode: "changeable",
                summaryPt: summaryPt,
                ...item,
              },
            };
            arr.push(obj);
            this.$router.addRoute("Index", obj);
          });
          this.addRouterList = [...this.addRouterList, ...arr];
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  background: linear-gradient(179deg, #f2f9ff, #e3e6f7);
  min-height: 800px;
}
</style>
